import { IMessage } from 'types';

export function filterMessagesByType(messages: Array<IMessage>, type: string): Array<IMessage> {
  if (messages.length > 0) {
    switch (type) {
      case 'note':
        return messages.filter(message => {
          return (
            message.messageType !== 'secure' &&
            message.messageType !== 'agent' &&
            message.messageType !== 'agentUni' &&
            message.messageType !== 'agentStudent'
          );
        });
      case 'agent':
        return messages.filter(message => {
          return (
            (message.messageType === 'agent' || message.messageType === 'agentUni') &&
            message.messageFrom &&
            message.messageFrom !== 'student' &&
            message.messageTo &&
            message.messageTo !== 'student'
          );
        });
      case 'secure':
        return messages.filter(message => {
          return message.messageType === 'secure';
        });
      case 'agentUni':
        return messages.filter(message => {
          return (
            message.messageType === 'agentUni' || (message.messageType === 'agent' && message.messageFrom === 'uni')
          );
        });
      case 'agentStudent':
        return messages.filter(message => {
          return (
            message.messageType === 'agentStudent' ||
            (message.messageType === 'agent' && message.messageFrom === 'student')
          );
        });
      default:
        return [];
    }
  }
  return [];
}
